import { jsonb, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';

import { tenantOrgIsolationPolicy } from './rls';

export const aiDecisionEvents = pgTable(
  'ai_decision_events',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id').notNull(), // no FK ref — audit must survive tenant deletion
    orgId: uuid('org_id').notNull(),
    candidateId: uuid('candidate_id'), // nullable — question generation has no candidate
    applicationId: uuid('application_id'), // optional — some decisions are candidate-level
    eventType: text('event_type').notNull(),
    payload: jsonb('payload').notNull(),
    actorType: text('actor_type', { enum: ['system', 'ai', 'human'] }).notNull(),
    actorId: text('actor_id'),
    occurredAt: timestamp('occurred_at').notNull()
    // No createdAt/updatedAt — occurredAt is the event timestamp; rows are never updated
  },
  () => [tenantOrgIsolationPolicy()]
).enableRLS();
